var iconData = require("./iconData.js");
var skillData = require("./skillData.js");
var skillIconUrl = {
	init:function(){

	},
	getUrl:function(skillStr){		
		for(var i=0;i<skillData.length;i++){
			if(skillStr==skillData[i].command){							
				var id=skillData[i].id;
				var icon=skillData[i].icon;
				for(var j=0;j<iconData.length;j++){
					var iconId=iconData[j].icon;
					var temp=iconId.split("_");
					var d=temp[temp.length-1];					
					if(d==icon){						
						return "https://nos.netease.com/tianyuapp/"+iconData[j].icon;
					}
				}
			}
		}
		return "";
	}
}
module.exports = skillIconUrl;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/skillIconUrl.js
// module id = 7
// module chunks = 0 1 3 4